module.exports = __webpack_public_path__ + "assets/images/pedra_dividir_8a1f81e0ab8427bda328fb77652aeec2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tela-montanha/pedra_dividir.png
// module id = 170
// module chunks = 0